/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Andere10Inputs */

const en__field_enum_tuda_andere10 = /** @type {(inputs: _Field_Enum_Tuda_Andere10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`other`)
};

const de__field_enum_tuda_andere10 = /** @type {(inputs: _Field_Enum_Tuda_Andere10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere`)
};

/**
* | output |
* | --- |
* | "other" |
*
* @param {_Field_Enum_Tuda_Andere10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_andere10 = /** @type {((inputs?: _Field_Enum_Tuda_Andere10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Andere10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_andere10(inputs)
	return de__field_enum_tuda_andere10(inputs)
});
export { _field_enum_tuda_andere10 as "_field_enum_TUDA_ANDERE" }